import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
	{
		path: '/404',
		name: '404',
		component: () => import('../views/404.vue'),
		meta: { title: '404' },
		hidden: true,
	},
	{
		path: '/sign-in',
		name: '登录',
		component: () => import('@/views/SignIn/index.vue'),
		meta: { title: 'signIn' },
		hidden: true,
	},
	{
		path: '/sign-up',
		name: '注册',
		component: () => import('../views/Sign-Up.vue'),
		meta: { title: 'signUp' },
		hidden: true,
	},
	{
		path: '/',
		redirect: '/dashboard',
		name: '首页',
		component: () => import('@/views/Dashboard/index'),
		meta: { title: '首页', layout: "dashboard", icon: "dashboard" },
		hidden: true,
	},
	{
		path: '/dashboard',
		name: '首页',
		component: () => import('@/views/Dashboard/index'),
		meta: { title: '首页', layout: "dashboard", icon: "dashboard", affix: true },
		hidden: false,
	},
]
export const asyncRoutes = [
	{
		path: '/user',
		name: '用户',
		component: () => import('@/views/User/index.vue'),
		meta: { title: '用户', layout: "dashboard", icon: "user", roles: ['admin'] },
		hidden: false,
	},
	{
		path: '/category',
		name: '类型分类',
		component: () => import('@/views/Category/index.vue'),
		meta: { title: '类型分类', layout: "dashboard", icon: "clipboard", noCache: false, roles: ['admin', 'user'] },
		hidden: false,
	},
	{
		path: '/keytype',
		name: '关键字类型',
		component: () => import('@/views/KeyType/index.vue'),
		meta: { title: '关键字类型', layout: "dashboard", icon: "guide", roles: ['admin', 'user'] },
		hidden: false,

	},
	{
		path: '/keywords',
		name: '关键字',
		component: () => import('@/views/KeyWords/index.vue'),
		meta: { title: '关键字', layout: "dashboard", icon: "tree", noCache: true, roles: ['admin', 'user'] },
		hidden: false,
	},
	{
		path: '/surge',
		name: '异常数据',
		component: () => import('@/views/Surge/index.vue'),
		meta: { title: '异常数据', layout: "dashboard", icon: "surge", roles: ['admin', 'user'] },
		hidden: false,
	},
	{
		path: '/showbiz',
		name: '娱乐圈',
		component: () => import('@/views/ShowBiz/index.vue'),
		meta: { title: '娱乐圈', layout: "dashboard", icon: "people", roles: ['admin', 'user'] },
		hidden: false,
	},
	{
		path: '/news',
		name: '每日热点',
		component: () => import('@/views/News/index.vue'),
		meta: { title: '每日热点', layout: "dashboard", icon: "language", roles: ['admin', 'user'] },
		hidden: false,
	},
	{
		path: '/etf',
		name: 'ETF基金',
		component: () => import('@/views/ETF/index.vue'),
		meta: { title: 'ETF基金', layout: "dashboard", icon: "example", roles: ['admin', 'user'] },
		hidden: false,
	},
	{
		path: '/gap',
		name: '跳空数据',
		component: () => import('@/views/Gap/index.vue'),
		meta: { title: '跳空数据', layout: "dashboard", icon: "money", roles: ['admin', 'user'] },
		hidden: false,
	},
	{
		path: '/keyword-chart',
		name: '关键字图表',
		component: () => import('../views/Charts/KeyWordChart/index.vue'),
		meta: { title: '关键字图表', roles: ['admin', 'user'] },
		hidden: true,
	},
	{
		path: '/keytype-chart',
		name: '关键字类型图表',
		component: () => import('../views/Charts/KeyTypeChart/index.vue'),
		meta: { title: '关键字类型图表', roles: ['admin', 'user'] },
		hidden: true,
	},
	{
		path: '/keyword-search-chart',
		name: '关键字搜索图表',
		component: () => import('../views/Charts/KwSearchChart/index.vue'),
		meta: { title: '关键字搜索图表', roles: ['admin', 'user'] },
		hidden: true,
	},
	{
		path: '/showbiz_keyword-chart',
		name: '娱乐圈关键字图表',
		component: () => import('../views/Charts/SbKeyWordChart/index.vue'),
		meta: { title: '娱乐圈关键字图表', roles: ['admin', 'user'] },
		hidden: true,
	},
	{
		path: '/etf_keyword-chart',
		name: 'ETF关键字图表',
		component: () => import('../views/Charts/EtfKeyWordChart/index.vue'),
		meta: { title: 'ETF关键字图表', roles: ['admin', 'user'] },
		hidden: true,
	},
	{
		path: '/etf_pcf-chart',
		name: 'ETF申赎清单',
		component: () => import('../views/Charts/EtfPcfChart/index.vue'),
		meta: { title: 'ETF申赎清单', roles: ['admin', 'user'] },
		hidden: true,
	},
	{
		path: '/showbizvideo',
		name: '娱乐圈视频',
		component: () => import('@/views/ShowBiz/videoindex.vue'),
		meta: { title: '娱乐圈视频', roles: ['admin', 'user'] },
		hidden: true,
	},
]

const createRouter = () => new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router